/** Translation key paths for the taxi office portal (DRY for templates and TypeScript). */
export const TAXI_OFFICE_KEYS = {
  shell: {
    navAria: 'taxiOffice.shell.navAria',
    brandTitle: 'taxiOffice.shell.brandTitle',
    brandSub: 'taxiOffice.shell.brandSub',
    providerPill: 'taxiOffice.shell.providerPill',
    tabOverview: 'taxiOffice.shell.tabOverview',
    tabDrivers: 'taxiOffice.shell.tabDrivers',
    tabSettlements: 'taxiOffice.shell.tabSettlements',
    languageAria: 'taxiOffice.shell.languageAria',
  },
  nav: {
    overview: 'taxiOffice.nav.overview',
    drivers: 'taxiOffice.nav.drivers',
    settlements: 'taxiOffice.nav.settlements',
    logout: 'taxiOffice.nav.logout',
  },
  header: {
    defaultTitle: 'taxiOffice.header.defaultTitle',
    subtitle: 'taxiOffice.header.subtitle',
    toggleMenu: 'taxiOffice.header.toggleMenu',
  },
  overview: {
    title: 'taxiOffice.overview.title',
    lead: 'taxiOffice.overview.lead',
    statDrivers: 'taxiOffice.overview.statDrivers',
    statOfficeWallet: 'taxiOffice.overview.statOfficeWallet',
    statDriverWallets: 'taxiOffice.overview.statDriverWallets',
    driversMeta: 'taxiOffice.overview.driversMeta',
    noOfficeBalance: 'taxiOffice.overview.noOfficeBalance',
    noPooledBalance: 'taxiOffice.overview.noPooledBalance',
    shortcutsAria: 'taxiOffice.overview.shortcutsAria',
    tileDriversTitle: 'taxiOffice.overview.tileDriversTitle',
    tileDriversDesc: 'taxiOffice.overview.tileDriversDesc',
    tileSettlementsTitle: 'taxiOffice.overview.tileSettlementsTitle',
    tileSettlementsDesc: 'taxiOffice.overview.tileSettlementsDesc',
    errorLoad: 'taxiOffice.overview.errorLoad',
  },
  drivers: {
    title: 'taxiOffice.drivers.title',
    lead: 'taxiOffice.drivers.lead',
    addDriver: 'taxiOffice.drivers.addDriver',
    settle: 'taxiOffice.drivers.settle',
    filterAria: 'taxiOffice.drivers.filterAria',
    filterAll: 'taxiOffice.drivers.filterAll',
    filterActive: 'taxiOffice.drivers.filterActive',
    filterInactive: 'taxiOffice.drivers.filterInactive',
    metaOne: 'taxiOffice.drivers.metaOne',
    metaMany: 'taxiOffice.drivers.metaMany',
    metaPage: 'taxiOffice.drivers.metaPage',
    colDriver: 'taxiOffice.drivers.colDriver',
    colPhone: 'taxiOffice.drivers.colPhone',
    colWallet: 'taxiOffice.drivers.colWallet',
    colStatus: 'taxiOffice.drivers.colStatus',
    colActions: 'taxiOffice.drivers.colActions',
    history: 'taxiOffice.drivers.history',
    unlink: 'taxiOffice.drivers.unlink',
    reactivate: 'taxiOffice.drivers.reactivate',
    emptyFilter: 'taxiOffice.drivers.emptyFilter',
    paginationAria: 'taxiOffice.drivers.paginationAria',
    previous: 'taxiOffice.drivers.previous',
    next: 'taxiOffice.drivers.next',
    pageOf: 'taxiOffice.drivers.pageOf',
    modalAddTitle: 'taxiOffice.drivers.modalAddTitle',
    modalSettleTitle: 'taxiOffice.drivers.modalSettleTitle',
    modalSettleHint: 'taxiOffice.drivers.modalSettleHint',
    labelName: 'taxiOffice.drivers.labelName',
    labelPhone: 'taxiOffice.drivers.labelPhone',
    labelDriver: 'taxiOffice.drivers.labelDriver',
    labelAmount: 'taxiOffice.drivers.labelAmount',
    chooseDriver: 'taxiOffice.drivers.chooseDriver',
    validationName: 'taxiOffice.drivers.validationName',
    validationPhone: 'taxiOffice.drivers.validationPhone',
    validationDriver: 'taxiOffice.drivers.validationDriver',
    validationAmount: 'taxiOffice.drivers.validationAmount',
    create: 'taxiOffice.drivers.create',
    submit: 'taxiOffice.drivers.submit',
    unlinkConfirm: 'taxiOffice.drivers.unlinkConfirm',
    toastAdded: 'taxiOffice.drivers.toastAdded',
    toastSettled: 'taxiOffice.drivers.toastSettled',
    toastUnlinked: 'taxiOffice.drivers.toastUnlinked',
    toastReactivated: 'taxiOffice.drivers.toastReactivated',
    errorLoad: 'taxiOffice.drivers.errorLoad',
    errorCreate: 'taxiOffice.drivers.errorCreate',
    errorSettle: 'taxiOffice.drivers.errorSettle',
    errorUpdate: 'taxiOffice.drivers.errorUpdate',
  },
  transactions: {
    title: 'taxiOffice.transactions.title',
    leadAll: 'taxiOffice.transactions.leadAll',
    leadFiltered: 'taxiOffice.transactions.leadFiltered',
    showAll: 'taxiOffice.transactions.showAll',
    labelDriver: 'taxiOffice.transactions.labelDriver',
    allDrivers: 'taxiOffice.transactions.allDrivers',
    labelFrom: 'taxiOffice.transactions.labelFrom',
    labelTo: 'taxiOffice.transactions.labelTo',
    apply: 'taxiOffice.transactions.apply',
    resetDriver: 'taxiOffice.transactions.resetDriver',
    metaOne: 'taxiOffice.transactions.metaOne',
    metaMany: 'taxiOffice.transactions.metaMany',
    metaPage: 'taxiOffice.transactions.metaPage',
    colWhen: 'taxiOffice.transactions.colWhen',
    colDriver: 'taxiOffice.transactions.colDriver',
    colAmount: 'taxiOffice.transactions.colAmount',
    colNote: 'taxiOffice.transactions.colNote',
    emptyRange: 'taxiOffice.transactions.emptyRange',
    paginationAria: 'taxiOffice.transactions.paginationAria',
    previous: 'taxiOffice.transactions.previous',
    next: 'taxiOffice.transactions.next',
    pageSlash: 'taxiOffice.transactions.pageSlash',
    errorLoad: 'taxiOffice.transactions.errorLoad',
  },
  login: {
    title: 'taxiOffice.login.title',
    lead: 'taxiOffice.login.lead',
    emailLabel: 'taxiOffice.login.emailLabel',
    emailPlaceholder: 'taxiOffice.login.emailPlaceholder',
    emailRequired: 'taxiOffice.login.emailRequired',
    emailInvalid: 'taxiOffice.login.emailInvalid',
    passwordLabel: 'taxiOffice.login.passwordLabel',
    showPassword: 'taxiOffice.login.showPassword',
    hidePassword: 'taxiOffice.login.hidePassword',
    passwordRequired: 'taxiOffice.login.passwordRequired',
    forgotPassword: 'taxiOffice.login.forgotPassword',
    signIn: 'taxiOffice.login.signIn',
    toastSignedIn: 'taxiOffice.login.toastSignedIn',
  },
  setup: {
    title: 'taxiOffice.setup.title',
    lead: 'taxiOffice.setup.lead',
    passwordLabel: 'taxiOffice.setup.passwordLabel',
    confirmPasswordLabel: 'taxiOffice.setup.confirmPasswordLabel',
    passwordRequired: 'taxiOffice.setup.passwordRequired',
    passwordMinLength: 'taxiOffice.setup.passwordMinLength',
    confirmRequired: 'taxiOffice.setup.confirmRequired',
    passwordsMismatch: 'taxiOffice.setup.passwordsMismatch',
    activate: 'taxiOffice.setup.activate',
    errorSession: 'taxiOffice.setup.errorSession',
    errorInvitation: 'taxiOffice.setup.errorInvitation',
    success: 'taxiOffice.setup.success',
    successSignIn: 'taxiOffice.setup.successSignIn',
  },
  status: {
    ACTIVE: 'taxiOffice.status.ACTIVE',
    INACTIVE: 'taxiOffice.status.INACTIVE',
  },
  common: {
    close: 'common.close',
    cancel: 'common.cancel',
    emptyDash: 'common.emptyDash',
  },
} as const;
